import * as React from 'react';
import { useField } from 'formik';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import { hasValue } from './inputHelpers.tsx';
import { withStyles } from '@material-ui/core';
import 'react-phone-input-material-ui/lib/style.css';
import "../../utils/lang/i18n";
import { useTranslation } from 'react-i18next';
import ReactPhoneInput from 'react-phone-input-material-ui';

interface IProps {
  name: string;
  isHidden?: boolean;
}
const styles = theme => ({});

const XPhone = ({
  name,
  isHidden = false,
  helperText,
  margin = 'normal',
  ...props
}: TextFieldProps & IProps) => {
  const [field, meta, helpers] = useField({ name });
  const { t, i18n } = useTranslation();
  const [value, setValue] = React.useState(field.value || ''); // Store the value in state
  const inputRef = React.useRef(null);

  React.useEffect(() => {
    if (field.value !== value) {
      setValue(field.value || '');
    }
  }, [field.value]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event;
    setValue(newValue);
    helpers.setValue(newValue); // Update Formik's field value
  };
  const { classes } = props;
  const error = hasValue(meta.error) ? meta.error : undefined;
  const showError = Boolean(error && meta.touched);
  if (isHidden) {
    return <input type="hidden" name={field.name} value={field.value} onChange={field.onChange} />;
  }
  return (
<ReactPhoneInput
      {...field}
      {...props}
      margin={margin}
      country={i18n.language === 'pt_br'? 'br' : 'us'}
      fullWidth
      error={showError}
      helperText={(showError && error) || helperText }
      value={field.value || ''}
      autoComplete="nope"
      onChange={handleChange}
      inputRef={inputRef}
      component={TextField}
      inputClass={classes.field}
      dropdownClass={classes.countryList}
    />
  );
};

export default  withStyles(styles)(XPhone);
